import { servicesApi } from './api';
import type {
  ServiceRequestListResponse,
  ServiceRequestListParams,
  ServiceRequestStats,
  ServiceRequestPendingCount,
  ServiceRequestItem,
  ReviewServiceRequestBody,
  CreatedCategory,
  CreateCategoryBody,
  ServiceCategory,
} from '../types/serviceRequests';

const BASE_PATH = '/admin/service-requests';

export const getList = async (params?: ServiceRequestListParams): Promise<ServiceRequestListResponse> => {
  const response = await servicesApi.get(BASE_PATH, { params });
  return response.data.data;
};

export const getStats = async (): Promise<ServiceRequestStats> => {
  const response = await servicesApi.get(`${BASE_PATH}/stats`);
  return response.data.data;
};

export const getPendingCount = async (): Promise<ServiceRequestPendingCount> => {
  const response = await servicesApi.get(`${BASE_PATH}/pending-count`);
  return response.data.data;
};

export const getDetail = async (id: number): Promise<ServiceRequestItem> => {
  const response = await servicesApi.get(`${BASE_PATH}/${id}`);
  return response.data.data;
};

export const startReview = async (id: number): Promise<ServiceRequestItem> => {
  const response = await servicesApi.post(`${BASE_PATH}/${id}/start-review`);
  return response.data.data;
};

export const review = async (id: number, body: ReviewServiceRequestBody): Promise<ServiceRequestItem> => {
  const response = await servicesApi.post(`${BASE_PATH}/${id}/review`, body);
  return response.data.data;
};

export const listCategories = async (): Promise<ServiceCategory[]> => {
  const response = await servicesApi.get(`${BASE_PATH}/categories`);
  return response.data.data;
};

export const createCategory = async (body: CreateCategoryBody): Promise<CreatedCategory> => {
  const response = await servicesApi.post(`${BASE_PATH}/categories`, body);
  return response.data.data;
};

export const serviceRequestsService = {
  getList,
  getStats,
  getPendingCount,
  getDetail,
  startReview,
  review,
  listCategories,
  createCategory,
};

export default serviceRequestsService;
